export default __webpack_public_path__ + "static/media/metamask1.d2cc35dd.png";